<template>
  <div>
    <VBusHelper
      :reactOn="$constants.EVENTS.DEALS.SHOW_DETAIL"
      :handler="showDetails"
    />
    <DialogComponent
      ref="dialog"
      type="fullscreen"
      noInnerPadding
      hideCloseButton
    >
      <DealDetailPage
        v-if="dealId && !isLoading"
        :dealId="dealId"
        @close="() => $refs.dialog.hide()"
      />
      <!-- Loading state -->
      <div v-else class="h-full flex flex-col bg-white">
        <div class="mobile-margin-top py-4 px-6 flex items-center gap-3">
          <div class="w-10 h-10 rounded-full shimmerElement"></div>
          <div class="h-8 w-48 shimmerElement rounded-xl"></div>
        </div>
        <div class="px-6 mt-10">
           <div class="w-full h-48 rounded-[2rem] shimmerElement"></div>
        </div>
        <div class="px-6 mt-10 space-y-6">
           <div class="h-6 w-32 shimmerElement rounded-lg"></div>
           <div class="h-32 w-full shimmerElement rounded-2xl"></div>
           <div class="h-32 w-full shimmerElement rounded-2xl"></div>
        </div>
      </div>
    </DialogComponent>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue';
import DealDetailPage from './DealDetailPage.vue';

const dialog = ref(null);
const dealId = ref(null);
const isLoading = ref(false);
const { proxy } = getCurrentInstance();
const { $constants } = proxy;

const showDetails = (id) => {
  if (!id) return;
  // Si id est un objet (provenant d'un payload d'événement), extraire l'id
  const actualId = typeof id === 'object' ? id.id : id;
  
  dealId.value = actualId;
  dialog.value.show();
};
</script>
